import { Component } from '@angular/core';
import { UtilityHelper } from '../../../core/helper/utility-helper';
import { Router, RouterLink } from '@angular/router';
import { WebService } from '../../../core/services/web-service/web.service';
import { environment } from '../../../../environments/environment';
import { CommonModule } from '@angular/common';
declare var $: any;
@Component({
  selector: 'app-category-list',
  standalone: true,
  imports: [RouterLink, CommonModule],
  templateUrl: './category-list.component.html',
  styleUrl: './category-list.component.scss',
})
export class CategoryListComponent {
  isLoading: boolean = true;
  DataList: any[] = [];
  imageBaseUrl = environment.imageBaseUrl;
  isSliderInitialized = false;
  constructor(
    private utility: UtilityHelper,
    private router: Router,
    private WebService: WebService
  ) {
    this.getCategoryListData();
  }
  encryptId(id: any): string {
    return this.utility.encryptLinkParams(id.toString());
  }
  navigateToShopDetail(
    categoryId: string,
    subCategoryId: string,
    dynamicSlug: string
  ): void {
    const encryptedId = this.encryptId(categoryId);
    const encryptedSubCatId = this.encryptId(subCategoryId);
    this.router.navigate([`cn/${dynamicSlug}`, encryptedId, encryptedSubCatId]);
  }
  navigateToCatSubList(dynamicSlug: string): void {
    this.router.navigate([`cat/sb/${dynamicSlug}`]);
  }

  ngOnInit() {

    this.WebService.categoryDatalist$.subscribe((data) => {
      if (data?.status === 200) {
        this.DataList = data.data;
      } else {
        this.DataList = [];
      }
    });
  }

  ngAfterViewChecked(): void {
    if (!this.isSliderInitialized && this.DataList.length > 0) {
      this.initializeSlick();
    }
  }
  getCategoryListData() {
    this.isLoading = true;
    const responseNull = true
    this.WebService.getCategoryList().subscribe((response: any) => {
      if (response?.status == 200) {
        //  this.DataList = response.data;
        this.WebService.categoryData(response);
        this.initializeSlick();
      } else {
        this.WebService.categoryData(response);
        this.initializeSlick();
        this.DataList = [];
      }
      this.isLoading = false;
      const responseNull = false
      this.WebService.categoryrDataNullRespone(responseNull);
    });
  }
  initializeSlick(): void {
    setTimeout(() => {
      $('.category-slider').not('.slick-initialized').slick({
        dots: false,
        infinite: true,
        speed: 500,
         slidesToShow: 6,
         slidesToScroll: 6,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        responsive: [
      {
        breakpoint: 1745,
        settings: {
            slidesToShow: 7,
        }
    },
      {
          breakpoint: 1399,
          settings: {
              slidesToShow: 6,
          }
      },
      {
          breakpoint: 1124,
          settings: {
              slidesToShow: 5,
          }
      },
      {
          breakpoint: 900,
          settings: {
              slidesToShow: 4,
          }
      },
      {
          breakpoint: 692,
          settings: {
              slidesToShow: 3,
          }
      }, {
          breakpoint: 482,
          settings: {
              slidesToShow: 3,
          }
      },
  ]
      });
      this.isSliderInitialized = true;
    });
  }


}
